

// import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";

function Contacts() {



    return <div className="absolute top-12 right-10 text-white flex w-20">
        <a target="_blank" href="https://github.com/kakolla" className="flex-auto fa fa-github"></a>
        <a target="_blank" href="https://www.linkedin.com/in/kakolla" className="flex-auto fa fa-linkedin-square"></a>
        <a href="mailto:kakolla@usc.edu" className="fa fa-envelope color-white"></a>

    </div>;
}


export default Contacts;